import { render, staticRenderFns } from "./ProfileRatingWidgetUnAuth.vue?vue&type=template&id=85b91abc&"
import script from "./ProfileRatingWidgetUnAuth.vue?vue&type=script&lang=js&"
export * from "./ProfileRatingWidgetUnAuth.vue?vue&type=script&lang=js&"
import style0 from "./ProfileRatingWidgetUnAuth.vue?vue&type=style&index=0&id=85b91abc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports